import React, { useMemo, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { ModalContext } from '@/context/modalContext';
import { useAnalyticsContext } from '@/context/analyticsContext';
import { autoOpenedStatusSessionKey } from '@/constants';

export const ModalProvider = ({ children }) => {
  const [modalName, setModalName] = useState('');
  const { customTrack } = useAnalyticsContext();

  const closeModal = useCallback(
    (event, detail) => {
      window.sessionStorage.setItem(autoOpenedStatusSessionKey, '1');
      if (detail) {
        customTrack({ event, detail });
      }
      setModalName('');
    },
    [customTrack]
  );

  const memoizedModalContext = useMemo(
    () => ({
      closeModal,
      modalName,
      setModalName,
    }),
    [modalName, setModalName, closeModal]
  );

  return (
    <ModalContext.Provider value={memoizedModalContext}>
      {children}
    </ModalContext.Provider>
  );
};

ModalProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
